import { heroBigTitle, stats, hotList } from "@/mocks/chigua";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="relative flex min-h-[620px] w-full items-center md:min-h-[640px]">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20stylized%20illustration%20of%20a%20crowd%20of%20curious%20silhouettes%20gathered%20around%20floating%20glowing%20speech%20bubbles%20and%20news%20cards%20on%20a%20warm%20coral%20orange%20to%20amber%20gradient%20background%2C%20energetic%20gossip%20culture%20scene%2C%20modern%20flat%20editorial%20pop%20art%2C%20vibrant%20high%20detail&width=1800&height=1000&seq=hero-chigua-01&orientation=landscape"
          alt="看吃瓜围观现场主题插画背景"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/35 to-black/20"></div>

        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-20">
          <div className="max-w-2xl">
            <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm ring-1 ring-background-50/30">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-pulse-soft rounded-full bg-accent-400"></span>
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-accent-300"></span>
              </span>
              全网热议事件正在发酵 · 围观群众已就位
            </p>
            <h1 className="mt-6 font-fun text-5xl leading-[1.1] text-background-50 md:text-7xl">
              {heroBigTitle[0]}
              <span className="mt-1 block text-accent-300">{heroBigTitle[1]}</span>
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-background-50/90">
              从热点爆料到爆款大瓜，我们把来龙去脉一次捋清楚。不管是大瓜小瓜，
              在这里都能吃明白——不用到处翻，热门话题的节奏分分钟跟上。
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href="#live"
                className="whitespace-nowrap rounded-full bg-accent-400 px-6 py-3 text-base font-bold text-primary-950 transition-colors hover:bg-accent-300"
              >
                <i className="ri-fire-fill mr-2" aria-hidden="true"></i>去现场吃瓜
              </a>
              <a
                href="#hot"
                className="whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-6 py-3 text-base font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/25"
              >
                先看实时热榜
              </a>
            </div>

            <dl className="mt-10 grid max-w-xl grid-cols-2 gap-px overflow-hidden rounded-2xl border border-background-50/20 bg-background-50/10 backdrop-blur-sm sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="px-4 py-4 text-center">
                  <dt className="order-last text-xs text-background-50/75">{s.label}</dt>
                  <dd className="font-fun text-2xl text-background-50">{s.num}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>

      <div className="relative border-y border-primary-200/50 bg-primary-500 py-2.5 text-background-50">
        <div className="overflow-hidden whitespace-nowrap">
          <div className="inline-block animate-ticker">
            {[0, 1].map((rep) => (
              <span key={rep} className="inline-flex">
                {hotList.map((h, i) => (
                  <span key={`${rep}-${i}`} className="inline-flex items-center">
                    <span className="mx-5 inline-flex items-center gap-1.5">
                      <i className="ri-flashlight-fill text-accent-200" aria-hidden="true"></i>
                      <span className="font-medium">{h.title}</span>
                    </span>
                    <span className="text-accent-200">·</span>
                  </span>
                ))}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}